export default __webpack_public_path__ + "static/media/pavers-facade.33949f39.jpg";